import { Controller } from "stimulus";

export default class extends Controller {
  submit(event) {
    event.preventDefault();
    let form = document.querySelector("#new_bonus_calculation");
    const alert = document.getElementById("bonus_calculation_alert");
    if (this.invalidInputs() > 0) {
      alert.classList.remove("d-none");
      this.scrollToTop();
      return 0;
    } else {
      alert.classList.add("d-none");
      form.submit();
    }
  }

  enableSubmitButton() {
    document.getElementById("submitButton").disabled = false;
  }

  scrollToTop() {
    let container = $(".wrapper.full").length ? $(".wrapper.full") : $([document.documentElement, document.body]);
    container.scrollTop(0);
  }

  containsSymbols(value) {
    // Define a regular expression pattern that matches symbols
    const pattern = /[^0-9,.]/;

    // Use the test() method to check if the value contains any symbols
    return pattern.test(value);
  }

  invalidInputs() {
    const invalidFields = [];
    let createdAt = document.getElementById("bonus_calculation_created_at");
    let goldPrice = document.getElementById("bonus_calculation_gold_price");
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    if (createdAt.value < 2023 || createdAt.value > currentYear) {
      createdAt.classList.add("is-invalid");
      invalidFields.push(createdAt);
      goldPrice.classList.remove("is-invalid");
    } else if (parseFloat(goldPrice.value) > 0 && !this.containsSymbols(goldPrice.value)) {
      goldPrice.classList.remove("is-invalid");
      createdAt.classList.remove("is-invalid");
    } else {
      goldPrice.classList.add("is-invalid");
      createdAt.classList.remove("is-invalid");
      invalidFields.push(goldPrice);
    }
    return invalidFields.length;
  }
}
